module.exports = __webpack_public_path__ + "img/2000.b19a5199.jpg";